"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _Business = _interopRequireDefault(require("@material-ui/icons/Business"));

var _solarReact = require("@solar/solar-react");

var _ui = require("@probeton/ui");

var _UserBlocking = _interopRequireDefault(require("./UserBlocking"));

var _Certificate = require("../Certificate");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CustomerInfo = function CustomerInfo(_ref) {
  var person = _ref.person,
      customer = _ref.customer,
      handleUserBlock = _ref.handleUserBlock,
      handleUserUnblock = _ref.handleUserUnblock,
      setPdfOpen = _ref.setPdfOpen,
      setImageOpen = _ref.setImageOpen;
  var avatar = person.avatar,
      email = person.email,
      fullName = person.fullName,
      company = person.company;
  var downloads = (customer === null || customer === void 0 ? void 0 : customer.downloads) || [];
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.List, null, /*#__PURE__*/_react["default"].createElement(_ui.ProfileItem, {
    icon: /*#__PURE__*/_react["default"].createElement(_core.Avatar, {
      src: avatar && avatar.src
    }),
    textLabel: email,
    text: fullName
  }), company && /*#__PURE__*/_react["default"].createElement(_ui.ProfileItem, {
    icon: /*#__PURE__*/_react["default"].createElement(_Business["default"], null),
    text: company
  }), customer && handleUserBlock && /*#__PURE__*/_react["default"].createElement(_UserBlocking["default"], {
    blocked: customer.blocked,
    onBlock: handleUserBlock,
    onUnblock: handleUserUnblock
  }), downloads.length > 0 && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, "Downloads"), /*#__PURE__*/_react["default"].createElement(_Certificate.DownloadList, {
    downloads: downloads,
    setPdfOpen: setPdfOpen,
    setImageOpen: setImageOpen
  }))));
};

var _default = CustomerInfo;
exports["default"] = _default;